/* Aurum — theme behaviour
   Everything here answers a click: nothing animates on its own. */
(function () {
  'use strict';

  var config = {};
  try {
    config = JSON.parse(document.getElementById('aurum-config').textContent);
  } catch (e) {
    config = { routes: {} };
  }

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = config.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  }

  var lastFocused = null;

  function openOverlay(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('input, button, a[href]');
    if (focusable) focusable.focus();
  }

  function closeOverlay(el) {
    if (!el) return;
    el.removeAttribute('open');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-overlay][open]').forEach(closeOverlay);
    var dir = $('[data-directory][open]');
    if (dir) toggleDirectory(false);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openOverlay($('#' + opener.getAttribute('data-open')));
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeOverlay(closer.closest('[data-overlay]'));
    }
  });

  /* ---------- department directory ---------- */

  function toggleDirectory(force) {
    var panel = $('[data-directory]');
    var trigger = $('[data-directory-trigger]');
    if (!panel || !trigger) return;
    var isOpen = panel.hasAttribute('open');
    var next = typeof force === 'boolean' ? force : !isOpen;
    if (next) { panel.setAttribute('open', ''); } else { panel.removeAttribute('open'); }
    trigger.setAttribute('aria-expanded', String(next));
  }

  var directoryTrigger = $('[data-directory-trigger]');
  if (directoryTrigger) {
    directoryTrigger.addEventListener('click', function () { toggleDirectory(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-directory]') || e.target.closest('[data-directory-trigger]')) return;
      toggleDirectory(false);
    });
  }

  /* ---------- quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */

  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- variant picker ---------- */

  $$('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var submit = form.querySelector('[data-add-button]');
    var stockEl = form.querySelector('[data-variant-stock]');
    var skuEl = form.querySelector('[data-variant-sku]');

    function selectedOptions() {
      return $$('[data-option-index]', form)
        .filter(function (el) { return el.type !== 'radio' || el.checked; })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (el) { return el.value; });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!match) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());

      if (priceEl) {
        var html = '<span class="price__now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="price__was">' + money(match.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
      }

      if (skuEl) skuEl.textContent = match.sku || '';

      if (stockEl) {
        stockEl.className = 'stock' + (match.available ? '' : ' stock--out');
        stockEl.textContent = match.available ? 'In stock, ships in 1–2 business days' : 'Sold out';
      }

      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to cart' : 'Sold out';
    }

    $$('[data-option-index]', form).forEach(function (el) {
      el.addEventListener('change', function () {
        var wrapper = el.closest('[data-option-wrapper]');
        if (wrapper) {
          var label = wrapper.querySelector('[data-selected-value]');
          if (label) label.textContent = el.value;
        }
        update();
      });
    });
  });

  /* ---------- cart ---------- */

  function refreshCartCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('hide', cart.item_count === 0);
    });
  }

  function renderDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var drawer = $('#cart-drawer');
        if (!drawer) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      });
  }

  function addToCart(form, button) {
    var body = new FormData(form);
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    return fetch(config.routes.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'This item could not be added.');
        return fetch(config.routes.cart ? config.routes.cart + '.js' : '/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart);
        if (config.cartType === 'drawer') {
          return renderDrawer().then(function () { openOverlay($('#cart-drawer')); });
        }
        window.location.href = config.routes.cart || '/cart';
      })
      .catch(function (err) {
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = err.message; note.classList.remove('hide'); }
        else { alert(err.message); }
      })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = original; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  function changeLine(key, quantity) {
    return fetch(config.routes.cart_change || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartCount(cart);
        if ($('#cart-drawer')) renderDrawer();
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0);
  });

  /* ---------- predictive search ---------- */

  var searchInput = $('[data-predictive-input]');
  if (searchInput) {
    var results = $('[data-predictive-results]');
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var term = searchInput.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = (config.routes.predictive || '/search/suggest') +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var list = parsed.querySelector('[data-predictive-inner]');
            results.innerHTML = list ? list.innerHTML : '';
          });
      }, 220);
    });
  }
})();
